import {
    ADD_POST,
    REMOVE_POST,
    UPDATE_POST,
    RESET_POSTS,
    SET_SELECTED_POST,
    TOGGLE_POST_SELECTION,
    RECEIVER_USER_DETAILS,
    RECEIVER_CHOOSED_PLATEFORM,
    IS_USER_WANT_DESIGN_GIFTCARD,
    SHOW_GIFT_DESIGN_PANEL,
    HIDE_GIFT_DESIGN_PANEL
} from './actionTypes.js';

const initialState = {
    isShowGiftDesignModel: false,
    posts: [],
    postCount: 0,
    selectedPost: null,
    // New receiver-related state
    giftReceiverDetails: {
        name: '',
        email: '',
        phone: ''
    },
    sharePlateform: null,
    isUserWantDesignGiftCard: false
};

function giftCardReducer(state = initialState, action) {
    switch (action.type) {
        // Keep all existing post cases exactly the same
        case ADD_POST:
            const shouldSelectFirstPost = state.posts.length === 0 && !state.selectedPost;
            return {
                ...state,
                posts: [...state.posts, action.payload],
                postCount: state.postCount + 1,
                selectedPost: shouldSelectFirstPost ? action.payload : state.selectedPost
            };

        case REMOVE_POST:
            const remainingPosts = state.posts.filter(post => post.id !== action.payload);
            const newSelectedPost =
                state.selectedPost?.id === action.payload
                    ? remainingPosts[0] || null
                    : state.selectedPost;
            return {
                ...state,
                posts: remainingPosts,
                postCount: state.postCount - 1,
                selectedPost: newSelectedPost
            };

        case UPDATE_POST:
            return {
                ...state,
                posts: state.posts.map(post =>
                    post.id === action.payload.id
                        ? { ...post, ...action.payload.updates }
                        : post
                ),
                selectedPost: state.selectedPost?.id === action.payload.id
                    ? { ...state.selectedPost, ...action.payload.updates }
                    : state.selectedPost
            };

        case SET_SELECTED_POST:
            return {
                ...state,
                posts: state.posts.map(post => ({
                    ...post,
                    isSelected: post.id === action.payload.id
                })),
                selectedPost: action.payload
            };

        case TOGGLE_POST_SELECTION:
            const postToToggle = state.posts.find(p => p.id === action.payload);
            const newSelectedState = postToToggle ? !postToToggle.isSelected : false;
            return {
                ...state,
                posts: state.posts.map(post =>
                    post.id === action.payload
                        ? { ...post, isSelected: newSelectedState }
                        : { ...post, isSelected: false }
                ),
                selectedPost: newSelectedState
                    ? state.posts.find(p => p.id === action.payload)
                    : null
            };

        case RESET_POSTS:
            return {
                ...initialState,
                // Preserve receiver details if needed during reset
                giftReceiverDetails: state.giftReceiverDetails,
                sharePlateform: state.sharePlateform
            };

        // NEW CASES FOR RECEIVER DETAILS
        case RECEIVER_USER_DETAILS:
            return {
                ...state,
                giftReceiverDetails: {
                    ...state.giftReceiverDetails,
                    ...action.payload
                }
            };

        case RECEIVER_CHOOSED_PLATEFORM:
            return {
                ...state,
                sharePlateform: action.payload
            };
        case IS_USER_WANT_DESIGN_GIFTCARD:
            return {
                ...state,
                isUserWantDesignGiftCard: action.payload
            };
        case SHOW_GIFT_DESIGN_PANEL:
            return {
                ...state,
                isShowGiftDesignModel: action.payload
            };
        case HIDE_GIFT_DESIGN_PANEL:
            return {
                ...state,
                isShowGiftDesignModel: action.payload
            };
        default:
            return state;
    }
}

export default giftCardReducer;
